import React from "react";
function Footer() {
  return (
    <>
      <div>
        <p className="pull-left p-t-5" style={{ fontSize: "80%" }}>
          ©{new Date().getFullYear()}{" "}
          <a href="https://immigration.go.tz"> Tanzania Immigration Services</a>
          . All Rights Reserved. (v1.4.03)
        </p>
      </div>
    </>
  );
}

export default Footer;
